import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'
import sizes from '../../theme/foundations/sizes'

export const containerStyle = {
    width: '100%',
    marginTop: pxToRem(16),
    marginBottom: pxToRem(8)
}

export const messageStyle = {
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: 500,
    color: 'cav_light_input_gray',
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    [`@media (max-width: ${sizes.container.md})`]: {
        fontSize: pxToRem(12)
    }
}
